import React from "react";

const BlogsHeader = () => {
  return (
    <>
      {/* Overlay */}
      <div className="w-full flex flex-row items-center justify-center pt-6">
        <div className="w-11/12 md:w-7/12 mx-auto">
          {/* Title */}
          <div className="text-3xl uppercase font-bold text-black">fashion</div>

          {/* Tags */}
          <div className="flex flex-row flex-wrap">
            <div className="inline-block bg-red-600 py-1.5 px-2.5 my-1.5 cursor-pointer uppercase text-white text-xs tracking-wider mr-3">
              fashion
            </div>
            <div className="inline-block bg-black py-1.5 px-2.5 my-1.5 cursor-pointer uppercase text-white text-xs tracking-wider mr-3">
              fashion
            </div>
            <div className="inline-block bg-yellow-600 py-1.5 px-2.5 my-1.5 cursor-pointer uppercase text-white text-xs tracking-wider mr-3">
              fashion
            </div>
            <div className="inline-block bg-purple-600 py-1.5 px-2.5 my-1.5 cursor-pointer uppercase text-white text-xs tracking-wider mr-3">
              fashion
            </div>
          </div>

          {/* Description */}
          <div className="italic text-black my-6 inline-block">
            Custom category description. You must learn one thing. The world was
            made to be free in. Give up all the other worlds Except the one in
            which you belong. Custom category description. You must learn one
            thing. The world was made to be free in.
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogsHeader;
